import { render, staticRenderFns } from "./crew-advoutstand.vue?vue&type=template&id=89a8fb8a&scoped=true"
import script from "./crew-advoutstand.vue?vue&type=script&lang=js"
export * from "./crew-advoutstand.vue?vue&type=script&lang=js"
import style0 from "./crew-advoutstand.vue?vue&type=style&index=0&id=89a8fb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a8fb8a",
  null
  
)

export default component.exports